import React from 'react';
import TitleBar from 'shared/migration-components/title-bar';
import {EditUser} from './components';
import {Container} from './styles';
import Tabs from 'shared/migration-components/tabs';

interface Props {
  activeTab?: string;
}

const DriverDetails: React.FC<Props> = ({activeTab}) => {
  return (
    <Container>
      <TitleBar title="Detalhes do usuário" />
      <Tabs
        {...{activeTab}}
        tabs={[
          {
            label: 'Detalhes',
            content: <EditUser />,
          },
        ]}
      />
    </Container>
  );
};

export default DriverDetails;
